import React, { useState } from "react";
import styled, { css } from "styled-components";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import QuestionIcon from "assets/icons/icon_question.svg";
import FlagIconChecked from "assets/icons/icon_flag_checked.svg";
import { MainLayout } from "layouts";
import { CenterListCard } from "components/all/settings";
import IconButton from "components/common/IconButton";
import Popup from "components/ui/Popup";
import Text from "components/ui/Text";
import Confirm from "components/ui/Confirm";
import Toast from "components/ui/Toast";
import { updatePartnerInfo } from "redux/slices/partner/partnerSlice";
import { updateMainCenter } from "api/mainCenter";

// 마지막글자가 받침으로 끝나는에 따라 을/를 구분하는 함수
const endWithConsonant = (text) => {
  const strGa = 44032; // 가
  const strHih = 55203; // 힣

  const lastStrCode = text.charCodeAt(text.length - 1);

  if (lastStrCode < strGa || lastStrCode > strHih) {
    return "를";
  }
  return (lastStrCode - strGa) % 28 == 0 ? "를" : "을";
};

const MainCenterSettings = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const partnerInfo = useSelector((state) => state.partner);
  const [open, setOpen] = useState(false);

  const rightComponent = () => (
    <IconBox onClick={() => setOpen(true)}>
      <IconButton src={QuestionIcon} />
    </IconBox>
  );
  const handleClickBranch = ({
    partner,
    partnerBranch,
    seqPartner,
    seqPartnerBranch,
  }) => {
    const partnerName = partnerBranch
      ? `${partner} ${partnerBranch}`
      : `${partner}`;
    Confirm(
      `${partnerName}${endWithConsonant(
        partnerName,
      )}\n주 관리센터로 설정하시겠어요?`,
      {
        title: "주 관리센터 설정",
        button: {
          left: { name: "취소", color: "gray20" },
          right: { name: "확인", color: "primary50" },
        },
        callback: (result) => {
          if (result) {
            updateMainCenter({
              seqPartner: seqPartner,
              seqPartnerBranch: seqPartnerBranch || 0,
            })
              .then(() => {
                dispatch(updatePartnerInfo());
                Toast("주 관리센터가 변경되었습니다", "check", "50px");
              })
              .catch((e) => {});
          }
        },
      },
    );
  };

  const handleClickSetting = (partnerObj) => {
    navigate("/all/settings/center", {
      state: partnerObj,
    });
  };

  return (
    <MainLayout
      withBottomTab={false}
      withHeader={true}
      backgroundColor="white"
      headerProps={{
        withBackButton: true,
        centerTitle: "내 센터 설정 관리",
        rightComponent: rightComponent,
      }}
    >
      <Wrapper>
        <Text
          color="gray80"
          fontSize="14px"
          lineHeight="18px"
          css={css`
            margin-bottom: 12px;
          `}
        >
          주 관리센터 설정
        </Text>
        <CenterListCard
          partnerInfo={partnerInfo}
          isSetting
          onClickBranch={handleClickBranch}
          onClickSetting={handleClickSetting}
        />
      </Wrapper>

      <Popup open={open} onClose={setOpen}>
        <WrapperPopup>
          <WrapperPopupTitle>
            <Text fontSize="18px" fontWeight="600" lineHeight="28px">
              연동센터관리
            </Text>
          </WrapperPopupTitle>
          <WrapperPopupContent>
            <PopupTitleBox>
              <img src={FlagIconChecked} width="16px" height="16px" />
              <Text color="primary50" fontWeight="700" lineHeight="24px">
                주 관리센터란?
              </Text>
            </PopupTitleBox>
            <PopupContentBox>
              <Text color="gray50" fontSize="13px">
                ･
              </Text>
              <Text color="gray50" fontSize="14px">
                관리중인 센터가 여러 개 있는 경우, 주 관리센터를 설정할 수
                있습니다.
              </Text>
            </PopupContentBox>
            <PopupContentBox>
              <Text color="gray50" fontSize="13px">
                ･
              </Text>
              <Text color="gray50" fontSize="14px">
                주 관리센터로 설정하면, 앱 실행 시 메뉴에서 기본 지정 센터로
                나타납니다.
              </Text>
            </PopupContentBox>
          </WrapperPopupContent>
        </WrapperPopup>
      </Popup>
    </MainLayout>
  );
};

const Wrapper = styled.div`
  width: 100%;
  height: auto;
  padding: 16px 20px;
`;

const IconBox = styled.div`
  padding: 12px 20px;
`;

const WrapperPopup = styled.div`
  padding: 2px 0 10px;
`;
const WrapperPopupTitle = styled.div`
  padding-bottom: 10px;
`;
const WrapperPopupContent = styled.div`
  margin: 16px 0;
`;
const PopupTitleBox = styled.div`
  display: flex;
  align-items: center;
  padding-bottom: 8px;
  img {
    margin-right: 6px;
  }
`;
const PopupContentBox = styled.div`
  display: flex;
  span:first-of-type {
    margin-right: 3px;
  }
`;

export default MainCenterSettings;
